<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <h5 class="mb-0">
            <i class="fas fa-building mr-2"></i>Empresas Asociadas y Calificaciones
          </h5>
        </div>
        <div class="col-md-6 text-right">
          <button class="btn bg-gradient-primary shadow-sm" data-target="#modal_empresas" data-toggle="modal"
            v-on:click="$parent.limpiarModalEmpresas()" v-if="form.estado == 1" :disabled="definitivo == 1">
            <i class="fa fa-plus"></i> Agregar Empresa
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-if="porcentajesEmpresa">
        <div v-for="item in porcentajesEmpresa" :key="item.empresa_id" class="mb-3">
          <!-- Header de la empresa -->
          <div class="card">
            <div class="card-header bg-light">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-building text-muted mr-2"></i>
                    <div>
                      <strong>{{ item.razon_social }}</strong>
                      <br>
                      <h6>Porcentaje Total:
                        <span class="badge shadow-sm"
                          :class="item.total_porcentaje == 100 ? 'bg-gradient-success' : 'bg-gradient-warning'">{{
                            item.total_porcentaje.toFixed(2) || 0 }}%
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 text-right">
                  <button class="btn btn-sm bg-gradient-danger shadow-sm" v-if="form.estado == 1" v-on:click="
                    eliminarEmpresa(2, item.empresa_id)
                    ">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Tabla de items de la empresa -->
            <div class="card-body p-0" v-if="item.items && item.items.length > 0">
              <table class="table table-sm table-striped table-bordered table-hover mb-0">
                <thead class="bg-dark text-white">
                  <tr>
                    <th scope="col" class="text-center">
                      <i class="fas fa-tags mr-2"></i>Item
                    </th>
                    <th scope="col" class="text-center">
                      <i class="fas fa-clock mr-2"></i>Peso General
                    </th>
                    <th scope="col" class="text-center">
                      <i class="fas fa-star mr-2"></i>Porcentaje Ingresado
                    </th>
                    <th scope="col" class="text-center">
                      <i class="fas fa-star mr-2"></i>Calificación
                    </th>
                    <th scope="col" class="text-center">
                      <i class="fas fa-cogs mr-2"></i>Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="porcentajeEmpresa in item.items" :key="porcentajeEmpresa.id">
                    <td>
                      <div class="d-flex align-items-center">
                        <i class="fas fa-folder text-muted mr-2"></i>
                        {{ porcentajeEmpresa.porcentaje_item_evaluacion.nombre }}
                      </div>
                    </td>
                    <td class="text-center">
                      {{ porcentajeEmpresa.porcentaje_item_evaluacion.porcentaje }}%
                    </td>
                    <td class="text-center">
                      <div v-if="editingRowId === porcentajeEmpresa.id"
                        class="d-inline-flex align-items-center w-100 justify-content-center">
                        <input type="number" class="form-control form-control-sm w-auto text-center"
                          v-model.number="editingValue" min="0" step="0.01" />
                        <span class="ml-1">%</span>
                      </div>
                      <span v-else>
                        {{ porcentajeEmpresa.total_porcentaje_empresa }}%
                      </span>
                    </td>
                    <td class="text-center">

                      {{ porcentajeEmpresa.resultado_calificacion }}%
                    </td>
                    <td class="text-center">
                      <div v-if="form.estado == 1">
                        <template v-if="editingRowId === porcentajeEmpresa.id">
                          <button class="btn btn-sm bg-gradient-success mr-1 shadow-sm" @click="guardarEdicion(porcentajeEmpresa)">
                            <i class="fas fa-check"></i>
                          </button>
                          <button class="btn btn-sm bg-gradient-danger shadow-sm" @click="cancelarEdicion()">
                            <i class="fas fa-times"></i>
                          </button>
                        </template>
                        <button class="btn btn-sm bg-gradient-navy shadow-sm" v-else v-on:click="
                          editarCalificacion(
                            porcentajeEmpresa.id,
                            porcentajeEmpresa.total_porcentaje_empresa
                          )
                          ">
                          <i class="fa fa-edit"></i>
                        </button>
                      </div>
                      <span v-if="form.estado == 2" class="mx-2 text-muted">
                        <i class="fas fa-lock"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mensaje cuando no hay items -->
            <div class="card-body text-center" v-else>
              <div class="d-flex align-items-center justify-content-center">
                <i class="fas fa-folder text-muted mr-2"></i>
                <span class="text-muted">No hay items para esta empresa</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer of the target -->
    <div class="card-footer text-muted text-center">
      <strong><u>{{ $parent.numero_empresas }}</u> Empresas asociadas</strong>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "EmpresasAsociadas",
  props: {
    form: {
      type: Object,
      required: true
    },
    definitivo: {
      type: Number,
      default: 0
    },
    porcentajesEmpresa: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      editingRowId: null,
      editingValue: null,
    };
  },
  methods: {
    eliminarEmpresa(accion, empresa_id) {
      //se agrega al arreglo el id de la calificacion
      let data = {
        empresa_id: empresa_id,
        accion: accion,
        id_calificacion: this.form.id,
      }

      axios({
        method: "PUT",
        url: "/api/hidrocarburos/calificaciones/empresa",
        data: data,
      })
        .then((response) => {
          if (response.data == 2) {
            this.$swal({
              icon: "error",
              title: "la empresa ya se encuentra asignada",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else if (response.data == 1) {
            this.$swal({
              icon: "success",
              title: "la empresa se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.init();
          } else {
            this.$swal({
              icon: "success",
              title: "la empresa se elimino...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.init();
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title:
              "Ocurrio un error, Comuniquese con el administrador del sistema..." +
              e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    editarCalificacion(id, valorActual) {
      this.editingRowId = id;
      this.editingValue = valorActual;
    },

    cancelarEdicion() {
      this.editingRowId = null;
      this.editingValue = null;
    },

    guardarEdicion(porcentajeEmpresa) {
      if (this.editingRowId !== porcentajeEmpresa.id) {
        return;
      }

      const data = {
        id: porcentajeEmpresa.id,
        resultado_calificacion: this.editingValue,
        porcentanje_item_evaluacion_id: porcentajeEmpresa.porcentaje_item_evaluacion.id,
        empresa_id: porcentajeEmpresa.empresa_id,
        calificacion_id: this.form.id,
      };

      if (data.resultado_calificacion > 100) {
        this.$swal({
          icon: "error",
          title: "El valor no puede ser mayor a 100",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        });
      }
      if (data.resultado_calificacion < 0) {
        this.$swal({
          icon: "error",
          title: "El valor no puede ser menor a 0",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        });
      }
      if (!(data.resultado_calificacion > 100 || data.resultado_calificacion < 0)) {
        axios({
          method: "PUT",
          url: "/api/hidrocarburos/calificaciones/editar_calificacion",
          data: data,
        })
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Calificación actualizada",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true,
            });
            this.cancelarEdicion();
            this.$parent.init();
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error" + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    }
  }
};
</script>
